export default __webpack_public_path__ + "static/media/import-points-example.8b7c4471.xlsx";